import FlowList from "./components/FlowList/FlowList";

const flowSections = [...document.querySelectorAll('.flow-section')]
for (let section of flowSections) {
    new FlowList(section)
}